export default __webpack_public_path__ + "static/media/2215.9d29ece3.png";